// @AddIntl

import { assertNever, Locale } from '@repo/utils'
import { useRouter } from 'next/router'
import React, { useState } from 'react'

import { LocaleSelectorModal } from './locale-selector-modal/LocaleSelectorModal'
import Icon from '../../atoms/icons/icon/Icon'
import { useLocale } from '../../../hooks/use-locale'

type LocaleSelectorProps = {
  onLocaleChange?: (locale: Locale) => void
}

export function LocaleSelector({ onLocaleChange }: LocaleSelectorProps) {
  const [isModalOpen, setModalOpen] = useState(false)
  const router = useRouter()

  const handleOpenModal = () => {
    setModalOpen(true)
  }

  const handleCloseModal = () => {
    setModalOpen(false)
  }

  // Allow the client app to handle the locale change to resolve translations
  const handleLocaleChange = (locale: Locale) => {
    if (onLocaleChange) {
      onLocaleChange(locale)
    } else {
      // Default routing behavior
      router.push(router.pathname, router.asPath, { locale })
    }
  }

  return (
    <>
      <button
        className='flex items-center gap-1 text-sm'
        onClick={handleOpenModal}
      >
        <RenderFlag />
      </button>

      <LocaleSelectorModal
        onSubmit={handleLocaleChange}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </>
  )
}

const RenderFlag = () => {
  const { locale } = useLocale()
  switch (locale) {
    case 'de-de':
      return (
        <>
          <Icon name='germany-flag' size={20} />
          DE
        </>
      )
    case 'en-gb':
      return (
        <>
          <Icon name='uk-flag' size={20} />
          EN
        </>
      )
    case 'es-es':
      return (
        <>
          <Icon name='spain-flag' size={20} />
          ES
        </>
      )
    case 'fr-fr':
      return (
        <>
          <Icon name='french-flag' size={20} />
          FR
        </>
      )
    case 'fr-be':
      return (
        <>
          <Icon name='belgium-flag' size={20} />
          BE
        </>
      )
    case 'it-it':
      return (
        <>
          <Icon name='italy-flag' size={20} />
          IT
        </>
      )
    case 'nl-be':
      return (
        <>
          <Icon name='belgium-flag' size={20} />
          BE
        </>
      )
    case 'nl-nl':
      return (
        <>
          <Icon name='netherland-flag' size={20} />
          NL
        </>
      )
    default:
      assertNever(locale)
  }
}
